<template>
  <div>
    <v-dialog
      persistent
      :modelValue="props.modelValue"
      width="640"
      overlayOpacity="0.85"
      @update:modelValue="(...v) => emit('update:modelValue', ...v)"
    >
      <v-card flat>
        <v-card-title class="headline">Create new segment</v-card-title>
        <v-card-text class="create-new-promo-dialog">
          <RfInfo ref="systemInfo" :model="modelInfo" />
          <v-checkbox
            v-if="currApp?.flags?.scheduled_push"
            v-model="modelInfo.segment_type"
            trueValue="pinpoint"
            falseValue="custom"
            label="Push notification type"
            hideDetails
          ></v-checkbox>
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn
            size="large"
            class="cancel-btn"
            variant="outlined"
            width="100px"
            @click="emit('update:modelValue', false)"
            >Close</v-btn
          >
          <v-btn
            data-cy="create-segment--submit"
            size="large"
            variant="flat"
            color="success"
            style="min-width: 200px"
            @click="submitCreate"
            ><v-icon start>md:save</v-icon>Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <RfModalLoading :showDialog="loading" />
  </div>
</template>

<script setup lang="ts">
import RfInfo from "@/components/RfCommonCards/RfInfo.vue";
import RfModalLoading from "@/views/RfModalLoading.vue";
import { useToastsStore } from "@/pinia/toastsStore";
import { computed } from "vue";
import { useAppsStore } from "@/pinia/appsStore";
import { useSegmentStore } from "@/pinia/segmentStore";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const props = defineProps(["modelValue"]);
const emit = defineEmits(["update:modelValue"]);

const appsStore = useAppsStore();
const toastsStore = useToastsStore();
const segmentStore = useSegmentStore();
const route = useRoute();
const router = useRouter();
const currApp = computed(() => appsStore.app);

const modelInfo = ref({ segment_type: "custom" });
const loading = ref(false);
const systemInfo = ref<typeof RfInfo | null>(null);

const submitCreate = () => {
  loading.value = true;
  const newSegment = { ...modelInfo.value };
  systemInfo.value?.fillModel(newSegment);
  emit("update:modelValue", false);
  modelInfo.value = { segment_type: "custom" };
  segmentStore
    .create({
      appId: route.params.aid,
      modelSegment: newSegment,
    })
    .then(segment => {
      toastsStore.create({ type: "success", body: "Segment created successfully" });
      router.push({ path: `/apps/${currApp.value.id}/segments/${segment.id}` });
    })
    .catch(() => null)
    .finally(() => (loading.value = false));
};
</script>
